var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHsp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 343.334,
    height: 343.334,
    viewBox: "0 0 343.334 343.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-548.707 -340.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2393",
    "data-name": "Trac\\xE9 2393",
    d: "M706.87,512h-100.1v38.5Zm-100.1,0V473.5L706.87,512Z",
    fill: "#006",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382",
    "data-name": "Ellipse 382",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(548.707 530.149) rotate(-90)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2394",
    "data-name": "Trac\\xE9 2394",
    d: "M733.878,512h100.1v38.5Zm100.1,0V473.5L733.878,512Z",
    fill: "#006",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_383",
    "data-name": "Ellipse 383",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(856.041 530.149) rotate(-90)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2395",
    "data-name": "Trac\\xE9 2395",
    d: "M710.825,521.548,640.044,592.33l27.224,27.223ZM640.044,592.33,612.82,565.106l98.005-43.558Z",
    fill: "#d90000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384",
    "data-name": "Ellipse 384",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(611.821 646.216) rotate(-135)",
    fill: "#d90000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2396",
    "data-name": "Trac\\xE9 2396",
    d: "M729.923,502.452,800.7,431.67l27.224,27.224ZM800.7,431.67l-27.223-27.223-43.558,98.005Z",
    fill: "#ff8c00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_385",
    "data-name": "Ellipse 385",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(829.138 428.903) rotate(-135)",
    fill: "#ff8c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2397",
    "data-name": "Trac\\xE9 2397",
    d: "M710.825,502.452,640.044,431.67,612.82,458.894ZM640.044,431.67l27.224-27.223,43.557,98.005Z",
    fill: "#1d1d1d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386",
    "data-name": "Ellipse 386",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(586.156 403.446) rotate(-45)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2398",
    "data-name": "Trac\\xE9 2398",
    d: "M729.923,521.548,800.7,592.33,773.48,619.553ZM800.7,592.33l27.224-27.224-98.005-43.558Z",
    fill: "#1d1d1d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_387",
    "data-name": "Ellipse 387",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(803.471 620.764) rotate(-45)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2399",
    "data-name": "Trac\\xE9 2399",
    d: "M720.374,498.5V398.4h-38.5Zm0-100.1h38.5l-38.5,100.1Z",
    fill: "#d90000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(702.225 340.333)",
    fill: "#d90000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2400",
    "data-name": "Trac\\xE9 2400",
    d: "M720.374,525.5V625.6h-38.5Zm0,100.1h38.5l-38.5-100.1Z",
    fill: "#ff8c00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(702.225 647.667)",
    fill: "#ff8c00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsp);
export default __webpack_public_path__ + "static/media/hsp.30007ed4b820eba05dc59150356903c3.svg";
export { ForwardRef as ReactComponent };